import React from 'react';

// Fluxo: Disponível → Reservado → Vendido → Disponível (desfazer)
export const proximoStatus = (statusAtual) => {
  if (statusAtual === 'Disponível') return 'Reservado';
  if (statusAtual === 'Reservado')  return 'Vendido';
  return null; // Vendido não tem próximo automático
};

// Permite "voltar atrás" em qualquer status
export const statusAnterior = (statusAtual) => {
  if (statusAtual === 'Reservado') return 'Disponível';
  if (statusAtual === 'Vendido')   return 'Reservado';
  return null;
};

const CONFIG = {
  Reservado: {
    titulo:    'Marcar como Reservado',
    descricao: 'O produto ficará marcado como reservado no catálogo.',
    confirmar: 'Reservar',
    cor:       'bg-amber-500 hover:bg-amber-600 text-white',
  },
  Vendido: {
    titulo:    'Marcar como Vendido',
    descricao: 'O produto será marcado como vendido.',
    confirmar: 'Confirmar venda',
    cor:       'bg-gray-900 hover:bg-black text-white',
  },
  Disponível: {
    titulo:    'Voltar para Disponível',
    descricao: 'O produto voltará a aparecer como disponível no catálogo.',
    confirmar: 'Tornar disponível',
    cor:       'bg-emerald-600 hover:bg-emerald-700 text-white',
  },
};

const ModalStatus = ({ open, onClose, nomeProduto, novoStatus, onConfirmar, loading }) => {
  if (!open || !novoStatus) return null;

  const cfg = CONFIG[novoStatus];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={!loading ? onClose : undefined} />

      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-sm p-6">
        <h2 className="text-base font-semibold text-gray-900 mb-1">{cfg.titulo}</h2>
        <p className="text-sm font-medium text-gray-800 mb-1">{nomeProduto}</p>
        <p className="text-sm text-gray-500 mb-6">{cfg.descricao}</p>

        <div className="flex gap-3 justify-end">
          <button onClick={onClose} disabled={loading} className="btn-secondary">
            Cancelar
          </button>
          <button
            onClick={onConfirmar}
            disabled={loading}
            className={`inline-flex items-center justify-center px-4 py-2 rounded-lg font-medium text-sm
              disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${cfg.cor}`}
          >
            {loading ? 'Salvando...' : cfg.confirmar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalStatus;
